export default [
  {
    id: 'checkout-warning-terms-and-conditions',
    name: 'termsConditions',
    label: 'smb_acquisition_checkout.fields.terms_and_conditions.label',
    formatLabel: {
      type: 'link',
      value: 'https://hs.gympass.com/hubfs/SMB/SMB_files/US%20T&C.pdf',
      target: 'blank',
    },
    componentType: 'checkbox',
    columnSize: {
      small: 12,
      medium: 12,
    },
    validations: {
      primitiveType: 'boolean',
      required: true,
    },
  },
  {
    id: 'checkout-warning-employees-number-confirmation',
    name: 'employeesNumberConfirmation',
    label: 'smb_acquisition_checkout.fields.information_are_true.label',
    componentType: 'checkbox',
    columnSize: {
      small: 12,
      medium: 12,
    },
    validations: {
      primitiveType: 'boolean',
      required: true,
    },
  },
]
